// extracted by mini-css-extract-plugin
export default {"sideBar":"style_sideBar__4d-tt","content-name-user":"style_content-name-user__cylwt"};